import React, { useEffect }  from "react";
import { useParams } from 'react-router-dom';
import Card from "components/card";
import { connect } from "react-redux";
import { 
 getClientDetails, getClientTeamDetails
} from "../../../../redux/client/clientState";
import SectionHeader from "components/section/SectionHeader";
import PopupButton from "components/button/PopupButton";
import ClientTeamForm from "./components/ClientTeamForm";


const ViewClientTeam = ({
	clientDetails,
	getClientDetails,
  	getClientTeamDetails,
	...props
 }) => { 

	const { recordId } = props;
	const { clientId, teamId } = useParams();
    
	useEffect(() => {
		getClientDetails(clientId)
	}, [clientId, getClientDetails]);

	useEffect(() => {
		getClientTeamDetails({clientId, teamId});
	}, [teamId, clientId, getClientTeamDetails]);

	return (
	    <div className="mt-3">
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
				<Card extra={"w-full h-full p-4"}>
					<div className="content-wrapper p-5 mb-2 rounded-lg shadow-md">
						<SectionHeader title={clientDetails?.clt_name || "Client"} />
					</div>
					<div className="content-wrapper p-5 mb-2 rounded-lg shadow-md">
						<SectionHeader title="Team Info">
							<PopupButton id="edit_client_team" title="Edit Client Team" label="Edit" >
								<ClientTeamForm recordId={recordId} clientId={clientId} mode="edit"/>
							</PopupButton>
						</SectionHeader>
						<ClientTeamForm recordId={teamId} clientId={clientId} mode="view" />
					</div>
				</Card>
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
  clientDetails: state.client.clientDetails?.data,
  clientTeamDetails: state.client.clientTeamDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getClientDetails: (id) => dispatch(getClientDetails(id)),
	getClientTeamDetails: (id) => dispatch(getClientTeamDetails(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewClientTeam);